import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import useStore from '@/store/useStore';

const useSupabaseRealtime = () => {
  const { fetchMatches, fetchTeams } = useStore();

  useEffect(() => {
    // Subscribe to changes in the matches table
    const matchSub = supabase
      .channel('public:matches')
      .on('postgres_changes', { event: '*', schema: 'public', table: 'matches' }, () => {
        fetchMatches();
      })
      .subscribe();

    // Subscribe to changes in the teams table
    const teamSub = supabase
      .channel('public:teams')
      .on('postgres_changes', { event: '*', schema: 'public', table: 'teams' }, () => {
        fetchTeams();
      })
      .subscribe();

    return () => {
      supabase.removeChannel(matchSub);
      supabase.removeChannel(teamSub);
    };
  }, [fetchMatches, fetchTeams]);
};

export default useSupabaseRealtime; 